module.exports = {"singleCellRegions":[["Motor 1","Mot_1"],["Motor 2","Mot_2"],["Motor 3","Mot_3"],["Motor 4","Mot_4"],["Somatosensory 1","Som_1"],["Somatosensory 2","Som_2"],["Somatosensory 3","Som_3"],["Visual 1","Vis_1"],["Visual 2","Vis_2"],["Visual 3","Vis_3"],["Auditory 1","Aud_1"],["Auditory 2","Aud_2"],["Auditory 3","Aud_3"],["Prefrontal 1","Pfr_1"],["Prefrontal 2","Pfr_2"],["Prefrontal 3","Pfr_3"],["Prefrontal 4","Pfr_4"]],"regionList":["SPA","IMD","PVT","CL","PF","CM","PCN","RE","VPMpc","MD","LP","PO","AM","IAD","VA","VM","AD","AV","LD","VL","LGd","VB"]}


//////////////////
// WEBPACK FOOTER
// ./src/settings.json
// module id = 9
// module chunks = 0